module.exports = __webpack_public_path__ + "img/icons.127ae97f.png";